

import { useState, useEffect } from "react";
import moment from "moment";
import Dashboard from "./components/Dashboard";
import ScheduleNach from "./components/ScheduleNach";
import { useSelector, useDispatch } from 'react-redux';
import { FILTER_ACTION } from '../../../../reducers/CommonFilters.reducer';
import {
  getActivePaymentGatewayService
} from "../MISNew/API's/Actioncreator";

export default function MainContent({
  activeSubTab,
  activeTab,
  status,
  admin,
  allStatus,
  handleBack,
}) {
  const dispatch = useDispatch();
  const { fromDate: ReducerFrom, toDate: ReducerTo } = useSelector(state => state.FilterReduce.commonFilters);
  const [serviceProvider, setServiceProvider] = useState("")
   const [retryFilter, setRetryFilter] = useState("");
  const [gatewayList,setgatewayList] =useState([])
  const [commonFilter, setcommonFilter] = useState({
    fromDate: ReducerFrom,
    toDate: ReducerTo,
  });

  useEffect(()=>{
    getActivePaymentGatewayService(callback=>{
      setgatewayList(callback ?? [])
    })
  },[])


  useEffect(() => {
    setcommonFilter({
      fromDate: ReducerFrom, toDate: ReducerTo
    })

  }, [ReducerFrom, ReducerTo]);

  const handleFilter = (type, value) => {
    dispatch({ type: FILTER_ACTION, payload: { [type]: value } });
    setcommonFilter((prev) => ({
      ...prev,
      [type]: value
    }))
  }

  // ✅ Common Props (Global Access)
  const commonProps = {
    commonFilter,
    handleFilter,
    gatewayList,
    retryFilter,
    setRetryFilter
   
  };

  // ✅ Tab Mapping
  const tabComponentMap = {
    dashboard: (
      <Dashboard
        {...commonProps}
        leadStatus={status}
        admin={admin}
        allStatus={allStatus}
        handleBack={handleBack}
        serviceProvider={serviceProvider} setServiceProvider={setServiceProvider}
      />
    ),

    scheduledNach: (
      <ScheduleNach
        {...commonProps}
        activeSubTab={activeSubTab}
        handleBack={handleBack}
        serviceProvider={serviceProvider} setServiceProvider={setServiceProvider}
      />
    ),
  };

  return <>{tabComponentMap[activeTab] || null}</>;
}